module.exports = __webpack_public_path__ + "static/media/customer-10.616c35cd.jpg";